<template>
  <div 
    class="preview-container" 
    @click="changeMode"
    @mousedown="enableModal"
    @touchstart="enableModal"
    
    @mouseup="disableModal"
    @touchend="disableModal"
  >
    <div class="preview-content">
      <div class="preview-icon" v-if="showIcon">
        <i class="fas fa-clone" v-if="showCarouselIcon"></i>
        <i class="fas fa-video" v-else-if="showVideoIcon"></i>
      </div>

      <div class="preview-content-disabled" v-if="!data.available">
      </div>

      <img class="preview-img" :src="url" alt="preview" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviewContainer",
  props: {
    data: {},
    content: {},
  },
  data() {
    return {
      timeoutShowModal: null,
    };
  },
  methods: {
    changeMode() {
      this.$emit("changeMode");
    },
    enableModal() {
      if (this.timeoutShowModal) {
        clearTimeout(this.timeoutShowModal);
      }

      this.timeoutShowModal = setTimeout(() => {
        this.$emit("enableModal");
      }, 500);
    },
    disableModal() {
      if (this.timeoutShowModal) {
        clearTimeout(this.timeoutShowModal);
      }
    },
  },
  computed: {
    url() {
      return this.data.public_thumbnail_image_path.small;
    },
    showIcon() {
      return this.showVideoIcon || this.showCarouselIcon;
    },
    showVideoIcon() {
      return this.content.component === "movie";
    },
    showCarouselIcon() {
      return this.data.qElements > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-container {
  &:hover {
    cursor: pointer;
  }
}

.preview-container,
.preview-content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-content {
  position: relative;

  .preview-content-disabled {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url("/img/lock-white.png");
    background-size: calc(max(30px, min(40%, 75px)));
    background-repeat: no-repeat;
    background-position: center;
  }
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-icon {
  $SIZE: 1px;
  $POSITION: 1.25em;

  @media (max-width: 768px) {
    $POSITION: 1em;
    font-size: 1.25em;
  }

  width: $SIZE;
  height: $SIZE;
  font-size: 1.75em;
  color: white;
  text-shadow: 0 0 2px black;
  background-color: rgba(0, 0, 0, 0.5);
  
  top: $POSITION;
  right: $POSITION;
  position: absolute;
  z-index: 1;
  
  display: flex;
  justify-content: center;
  align-items: center;
}

.fa-clone {
  transform: rotate(-90deg);
}

</style>